import React from "react";
import styled from "styled-components/native";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import { SpaceType } from "@components/atoms/Spacer/types";

type ScrollButtonProps = {
  side: "left" | "right";
  onPress: () => void;
  iconColor: string;
  useMobileWebView?: boolean;
};

const ScrollButton = ({
  side,
  onPress,
  iconColor,
  useMobileWebView,
}: ScrollButtonProps) => {
  return (
    <ButtonWrapper
      side={side}
      onPress={onPress}
      useMobileWebView={useMobileWebView}
    >
      <VDBIcon
        color={iconColor}
        size={24}
        variant={IconsVariant.VDBCustom}
        name={
          side === "left"
            ? VDBIcons.ARROW_SCROLL_LEFT
            : VDBIcons.ARROW_SCROLL_RIGHT
        }
      />
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.TouchableOpacity<{
  side: "left" | "right";
  useMobileWebView?: boolean;
}>`
  position: absolute;
  background-color: ${({ theme }) => theme["core-03"]};
  padding: 0;
  border-radius: ${SpaceType.Basic}px;
  ${({ side, useMobileWebView }) =>
    side === "left"
      ? useMobileWebView
        ? `left: ${SpaceType.Extra}px;`
        : `left: 24px;`
      : useMobileWebView
      ? `right: ${SpaceType.Extra}px;`
      : `right: 24px;`};
  top: ${({
    theme,
    useMobileWebView,
  }: {
    theme: any;
    useMobileWebView: boolean;
  }) =>
    theme.isLargeScreen
      ? "18px"
      : useMobileWebView
      ? `${SpaceType.Extra}px`
      : `${SpaceType.Double}px`};
  z-index: 1;
`;

export default ScrollButton;
